var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.app},[_c('World',_vm._b({},'World',_vm.$attrs,false)),_c('PlayerStatus')],1)}
var staticRenderFns = []

export { render, staticRenderFns }